import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function WithdrawIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0016 7.50521C9.08113 7.50521 8.33496 8.06485 8.33496 8.75523C8.33496 9.44556 9.08113 10.0052 10.0016 10.0052C10.922 10.0052 11.6683 10.5649 11.6683 11.2552C11.6683 11.9456 10.922 12.5052 10.0016 12.5052M10.0016 7.50521C10.7273 7.50521 11.3446 7.85304 11.5734 8.33856M10.0016 7.50521V6.67188M10.0016 12.5052C9.27588 12.5052 8.65854 12.1574 8.42979 11.6719M10.0016 12.5052V13.3386"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />

      <path
        d="M10.8335 2.08984C10.8335 2.08984 10.5701 2.08984 10.0002 2.08984C6.26821 2.08984 4.40224 2.08984 3.24286 3.24922C2.0835 4.40859 2.0835 6.27456 2.0835 10.0065C2.0835 13.7384 2.0835 15.6044 3.24286 16.7639C4.40224 17.9232 6.26821 17.9232 10.0002 17.9232C13.7321 17.9232 15.5981 17.9232 16.7575 16.7639C17.9168 15.6044 17.9168 13.7384 17.9168 10.0065C17.9168 9.43661 17.9168 9.17319 17.9168 9.17319"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />

      <path
        d="M14.5 5.5L18 2M18 2H15.5M18 2V4.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
